var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBike = function SvgBike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#061F15",
    strokeMiterlimit: 10,
    strokeWidth: 0.545,
    d: "M4.642 3.82 2.676 6.965m.393-3.93h2.378m1.16 3.144L4.248 3.034m7.076 3.93L8.887 1.4A1.2 1.2 0 0 0 7.782.676H6.214m1.179 5.503 1.965-3.931M5.035 6.965a2.358 2.358 0 1 1-4.717 0 2.358 2.358 0 0 1 4.717 0Zm8.647 0a2.358 2.358 0 1 1-4.717 0 2.358 2.358 0 0 1 4.717 0Zm-5.896 0a.786.786 0 1 1-1.572 0 .786.786 0 0 1 1.572 0Z"
  })));
};
export default SvgBike;